import React, { useState } from 'react';
import './ice.css';

export default function IceForm() {
  const [file, setFile] = useState(null);
  const [loading, setLoading] = useState(false);
  const [result, setResult] = useState(null);
  const [dragActive, setDragActive] = useState(false);

  const handleFileSelect = (event) => {
    const file = event.target.files[0];
    if (file) {
      handleDrop({ dataTransfer: { files: [file] }, preventDefault: () => {}, stopPropagation: () => {} });
    }
  };

  const handleDragOver = (e) => {
    e.preventDefault();
    setDragActive(true);
  };

  const handleDragLeave = (e) => {
    e.preventDefault();
    setDragActive(false);
  };

  const handleDrop = (e) => {
    e.preventDefault();
    setDragActive(false);
    const droppedFile = e.dataTransfer.files[0];

    if (droppedFile && ['xlsx', 'xls', 'csv'].some(ext => droppedFile.name.endsWith(ext))) {
      setFile(droppedFile);
      uploadFile(droppedFile);
    } else {
      alert("❌ Invalid file type. Please upload an Excel or CSV file.");
    }
  };

  const uploadFile = async (file) => {
    const formData = new FormData();
    formData.append('file', file);
    setLoading(true);
    setResult(null);

    try {
      const response = await fetch("https://www.autatoms.com/upload", {
        method: 'POST',
        body: formData
      });

      const data = await response.json();
      if (response.ok && data.session_id) {
        const downloadUrl = `https://www.autatoms.com/download/${data.session_id}`;
        setResult({ url: downloadUrl });
      } else {
        setResult(data.error || "❌ Upload failed.");
      }
    } catch (err) {
      setResult("❌ Server not reachable.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      <div className="ice-form-wrapper">
        <h1 className="headline">Stop Writing Cold Emails That Feel… Cold</h1>
        <p className="subhead">Instantly generate personalized icebreakers that get replies for the first 10 links.</p>

        <div
          className={`upload-drop-zone ${dragActive ? 'drag-active' : ''}`}
          onDragOver={handleDragOver}
          onDragLeave={handleDragLeave}
          onDrop={handleDrop}
        >
          <div className="upload-button">Drag your file here</div>
          <span className="or-text">or drop it to upload automatically</span>

          <div className="manual-upload">
            <label htmlFor="file-upload" className="choose-file-label">
              Choose File
            </label>
            <input
              id="file-upload"
              type="file"
              accept=".csv, .xlsx, .xls"
              onChange={handleFileSelect}
              style={{ display: 'none' }}
            />
          </div>
        </div>

        {loading && <div className="loader">⏳ Uploading...</div>}

        {!loading && result && (
          <div className="icebreaker-box">
            <h3>Result</h3>
            <a
              href={result.url}
              target="_blank"
              rel="noopener noreferrer"
              className="download-btn"
            >
              ⬇️ Click here to download
            </a>
          </div>
        )}

        {!loading && !result && (
          <div className="icebreaker-box">
            <p className="placeholder">Waiting for file...</p>
          </div>
        )}

        {/* ➕ Informational Section Starts */}
        <div className="ice-info-section">
          <h2>Most cold emails get ignored.</h2>
          <p><strong>Why?</strong> Because they look, feel, and read like spam.</p>
          <p><strong>This tool changes that.</strong></p>

          <h3>How It Works (So Simple It Hurts)</h3>
          <ul>
            <li><strong>Drop your CSV/XLS file</strong><br />
              Drop a file with all the information that you have about the prospect. You can download a sample file here.
            </li>
            <li><strong>Let the AI work</strong><br />
              We scan each website, available information and write a human-sounding icebreaker.
            </li>
            <li><strong>Download your file</strong><br />
              Once it’s ready, the “Download” button below lights up.
            </li>
          </ul>

          <h3>Real Icebreakers. Not AI Mush.</h3>
          <p>Built by cold emailers, for cold emailers.</p>
          <p>These icebreakers don’t sound robotic, weird, or generic.</p>
          <p>They spark real conversations and boost your reply rate without extra research.</p>

          <h3>Who’s This For?</h3>
          <ul>
            <li>✅ SDRs & BDRs tired of 0% replies</li>
            <li>✅ Agency owners booking meetings via cold outreach</li>
            <li>✅ Founders doing manual prospecting</li>
            <li>✅ Anyone writing 10+ cold emails a day</li>
          </ul>

          <h3>Your First Line = Your First Impression</h3>
          <p>Every cold email lives or dies in the first 2 seconds.</p>
          <p>If your opener feels generic, robotic, or fake...</p>
          <p><strong>You're in the trash. No click. No reply. No sale.</strong></p>

          <p>That’s why we built this tool:</p>
          <p><strong>To help you write high-converting icebreakers without wasting hours researching websites or stalking LinkedIn.</strong></p>

          <p><strong>You upload. We write. You win.</strong></p>
          <ul>
            <li>✔️ More replies</li>
            <li>✔️ Less guesswork</li>
            <li>✔️ No burnout writing 100+ lines a week</li>
          </ul>

          <p><strong>Smart personalization = higher reply rate = more booked calls.</strong></p>
          <p>Use what you already know (name, company, website) and get icebreakers that feel like you spent 10 minutes on each one.</p>
          <p><strong>You didn’t.</strong></p>
          <p><strong>We did it for you.</strong></p>

          <h2>Ready to sound human at scale?</h2>
          <p><strong>Drop your list. Let’s write your best first lines yet.</strong></p>
        </div>
        {/* ➕ Informational Section Ends */}
      </div>

      {/* Footer */}
      <footer className="footer-section">
        
        <div className="footer-bottom">
          <div className="footer-links">
            <a href="#">Terms of Use</a>
            <a href="#">Privacy Policy</a>
            <a href="#">Cookie settings</a>
          </div>
          <div className="footer-icons">
            <a href="#"><img src="/icons/linkedin.svg" alt="LinkedIn" /></a>
            <a href="#"><img src="/icons/x.svg" alt="X" /></a>
            <a href="#"><img src="/icons/youtube.svg" alt="YouTube" /></a>
          </div>
        </div>
      </footer>
    </div>
  );
}
